import { docodeHexResponse } from '../../../_common/common.utils';
import AuditTrailReportActionTypes from './audit-trail-report.type';

const INITIAL_STATE = {
	getAuditTrailReportListResponse: null,
	getAuditTrailReportListArr: [],

	fetchPostAuditTrailExcelResponse: null,
	fetchPostAuditTrailExcelArr: [],
};

const auditTrailReportReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/******************* GET AUDIT TRAIL REPORT START *****************/
		case AuditTrailReportActionTypes.GET_AUDIT_TRAIL_REPORT_LIST_SUCCESS:
			return {
				...state,
				getAuditTrailReportListResponse: action.payload,
				getAuditTrailReportListArr: docodeHexResponse(
					action.payload,
					'AuditTrailReportKey',
				),
			};

		case AuditTrailReportActionTypes.GET_AUDIT_TRAIL_REPORT_LIST_FAILURE:
			return {
				...state,
				getAuditTrailReportListResponse: action.payload,
				getAuditTrailReportListArr: [],
			};

		case AuditTrailReportActionTypes.GET_AUDIT_TRAIL_REPORT_LIST_RESPONSE_CHANGED:
			return {
				...state,
				getAuditTrailReportListResponse: null,
			};
		/******************* GET AUDIT TRAIL REPORT END *****************/

		/** ***************** AUDIT TRAIL REPORT REPORT EXCEL START *********************** */
		case AuditTrailReportActionTypes.FETCH_POST_AUDIT_TRAIL_REPORT_EXCEL_SUCCESS:
			return {
				...state,
				fetchPostAuditTrailExcelResponse: action.payload,
				fetchPostAuditTrailExcelArr: docodeHexResponse(
					action.payload,
					'AuditTrailReportExcelKey',
				),
			};

		case AuditTrailReportActionTypes.FETCH_POST_AUDIT_TRAIL_REPORT_EXCEL_FAILURE:
			return {
				...state,
				fetchPostAuditTrailExcelResponse: null,
				fetchPostAuditTrailExcelArr: action.payload,
			};

		case AuditTrailReportActionTypes.FETCH_POST_AUDIT_TRAIL_REPORT_EXCEL_RESET:
			return { ...state, fetchPostAuditTrailExcelResponse: null };
		/** ***************** AUDIT TRAIL REPORT REPORT EXCEL END *********************** */

		/** ***************** FETCH POST AUDIT TRAIL REPORT JSON START *********************** */
		case AuditTrailReportActionTypes.FETCH_POST_AUDIT_TRAIL_REPORT_JSON_SUCCESS:
			return {
				...state,
				fetchPostAuditTrailJSONResponse: action.payload,
				fetchPostAuditTrailJSONArr: docodeHexResponse(
					action.payload,
					'AuditTrailReportJsonKey',
				),
			};

		case AuditTrailReportActionTypes.FETCH_POST_AUDIT_TRAIL_REPORT_JSON_FAILURE:
			return {
				...state,
				fetchPostAuditTrailJSONResponse: null,
				fetchPostAuditTrailJSONArr: action.payload,
			};

		case AuditTrailReportActionTypes.FETCH_POST_AUDIT_TRAIL_REPORT_JSON_RESET:
			return {
				...state,
				fetchPostAuditTrailJSONResponse: null,
				fetchPostAuditTrailJSONArr: [],
			};
		/** ***************** FETCH POST AUDIT TRAIL REPORT JSON END *********************** */

		default:
			return state;
	}
};

export default auditTrailReportReducer;
